import { render } from "./PendingCredits.vue?vue&type=template&id=38b28776&ts=true"
import script from "./PendingCredits.vue?vue&type=script&lang=ts"
export * from "./PendingCredits.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__